(() => {
  const root = document.documentElement;
  const transition = document.querySelector('.story-page-transition');
  if (!transition) return;

  let timer;
  let cleanupTimer;

  const play = (mode) => {
    clearTimeout(timer);
    clearTimeout(cleanupTimer);
    transition.classList.remove('is-finishing');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      delete root.dataset.storyTransition;
      return;
    }

    let image = transition.querySelector('.story-page-transition__animation');
    const still = transition.querySelector('.story-page-transition__still');
    if (still.complete && still.naturalWidth) {
      still.classList.add('is-ready');
    } else {
      still.addEventListener('load', () => still.classList.add('is-ready'), { once: true });
      if (!still.hasAttribute('src')) still.src = still.dataset.src;
    }
    if (image.hasAttribute('src')) {
      const freshImage = image.cloneNode();
      freshImage.classList.remove('is-ready');
      freshImage.removeAttribute('src');
      image.replaceWith(freshImage);
      image = freshImage;
    }
    root.dataset.storyTransition = mode;

    const start = () => {
      if (root.dataset.storyTransition !== mode) return;
      image.classList.add('is-ready');
      timer = setTimeout(() => {
        transition.classList.add('is-finishing');
        root.dataset.storyTransition = `leaving-${mode}`;
        cleanupTimer = setTimeout(() => {
          delete root.dataset.storyTransition;
        }, 280);
      }, 1900);
    };

    if (image.complete && image.naturalWidth) {
      start();
    } else {
      image.addEventListener('load', start, { once: true });
      image.addEventListener('error', () => {
        delete root.dataset.storyTransition;
      }, { once: true });
      if (!image.hasAttribute('src')) image.src = image.dataset.src;
    }
  };

  const initialMode = root.dataset.storyTransition;
  if (initialMode) play(initialMode);

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;

    try {
      const currentPage = location.pathname + location.search;
      const lastPage = sessionStorage.getItem('story-last-page');
      sessionStorage.setItem('story-last-page', currentPage);
      if (lastPage && lastPage !== currentPage) play('page');
    } catch (_) {
      // A restored page still works if storage is unavailable.
    }
  });
})();
